<template>
  <v-dialog
    v-model="sendDialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        depressed
        :disabled="!buyOrder.persons.length"
        :block="$vuetify.breakpoint.mdAndDown"
        :class="{ 'ml-2' : !$vuetify.breakpoint.mdAndDown }"
        class="my-1"
        v-on="on"
      >
        Lähetä allekirjoitettavaksi
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5">
        Lähetä allekirjoitettavaksi
      </v-card-title>
      <v-card-text class="pb-0">
        Olet lähettämässä linkin sähköisen ostotoimeksiantosopimuksen
        allekirjoitukseen seuraaville henkilöille:
        <p
          v-for="(person, idx) of buyOrder.persons"
          :key="idx"
          class="mt-4"
        >
          Nimi: <span class="primary--text ml-1">{{ person.name }}</span><br>
          Sähköposti: <span class="primary--text ml-1">{{ person.email }}</span>
        </p>
      </v-card-text>
      <v-card-actions class="pb-4 pr-4">
        <v-spacer/>
        <v-btn
          text
          @click="closeDialog()"
        >
          Peruuta
        </v-btn>
        <v-btn
          color="primary"
          text
          :loading="loading"
          @click="sendLinks()"
        >
          Lähetä
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { apiPost } from '../api';

export default {
  props: {
    buyOrder: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    sendDialog: false,
    loading: false,
  }),
  methods: {
    async sendLinks() {
      this.loading = true;
      await apiPost('buyorders/send-link', { id: this.$route.params.id });
      this.$bus.$emit('RELOAD_BUY_ORDER');
      this.closeDialog();
      this.loading = false;
    },
    closeDialog() {
      this.sendDialog = false;
    },
  },
};
</script>
